<template>
    <section v-if="hasPermissions(['Days-Off-Rotation-Setup Read', 'Days-Off-Rotation-Setup Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Templates. Click Add Rotation Template to create a Template. Fill in the Description, days in the rotation, day of the week the rotation begins , the scheduled start date and the Shift. Click Save.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="master_departments.length && hasPermissions(['Days-Off-Rotation-Setup Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <button v-if="hasPermissions(['Days-Off-Rotation-Setup Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Days-Off-Rotation-Setup Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="master_departments.length && hasPermissions(['Days-Off-Rotation-Setup Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="master_departments"
                                :search="search"
                                :checkable="true"
                                :link="'#'"
                                :historiable="false"
                                @history="history($event)"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Rotation Template'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Rotation Template Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <HelperModal :helps="helps"/>

        <WaitingModal/>
    </section>
   <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import Breadcrumb               from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal             from '@/components/WaitingModal'
import HelperModal              from    '@/components/HelperModal'
import Resources                from './resources'
import FormResources            from './form_resources'
import FormModal                from './FormModal'
import UpdateModal              from './UpdateModal'
import DinamicTable             from '@/components/DinamicTable'
import DeletionModal            from '@/components/DeletionModal'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    
    name: 'MasterDepartment',

    components: {
      Breadcrumb,
      WaitingModal,
      DeletionModal,
      FormModal,
      UpdateModal,
      DinamicTable,
      DeletionMassiveModal,
      UnauthorizedComponent,
      HelperModal
    },

    data() {
        return {
            notyf,
            user:               this.get_user(),
            child_href:         '/days-off-master-departments/',
            title_page:         'Rotation Templates',
            content_header:     this.$store.state.headers,
            rest_api:           `master_departments`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            schedule_options:   FormResources.schedule_options,
            add_btn:            'Add Rotation Template',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       0,
            single_object:      {},
            master_departments: [],
            array_options:      {},
            select_ids:         [],
            helps:              Resources.helps
        }
    },
    methods: {

        format_val(value)
        {
            let val = ''
            if(value === 1){
                val = 'Day'
            }else if(value === 2){
                val = 'Evening'
            }else if(value === 3){
                val = 'Night'
            }else{
                val = 'All shift'
            }
            return val
        },

        unshift_object(new_object)
        {
            this.master_departments.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.master_departments.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.master_departments[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = {...this.master_departments[index]}
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.master_departments = data.master_departments
        },

        trashing(index)
        {
            this.master_departments.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.master_departments.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.master_departments.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.master_departments.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['Days-Off-Rotation-Setup Read']))
        {
            await this.api_request()
        }
        this.array_options = {
            shift: FormResources.shift_option,
            schedule_day: this.schedule_options,
            day_rotations: FormResources.day_rotations
        }
    },

    computed:
    {
         selected()
        {
            const bool = this.master_departments.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }

}
</script>
